import { DocumentDisplayUomSettingsFields } from "~/components/domain/settings/documents/DocumentDisplayUomSettingsFields";
import { DocumentSettingsEditor } from "~/components/domain/settings/documents/DocumentSettingsEditor";
import { DocumentTypedSignatureSettingsField } from "~/components/domain/settings/documents/DocumentTypedSignatureSettingsField";
import { OptInOrderDocumentAccessInfoAlert } from "~/components/domain/settings/documents/OptInOrderDocumentAccessInfoAlert";
import { PickupInstructionsDocumentConfigSchema } from "~/modules/orders/order-documents/pickup-instructions/config.schema";
import { useOptInOrderDocumentSettingsForm } from "~/modules/orders/order-menu-document-extensions/useOptInOrderDocumentSettingsForm";
import { ORDER_DOCUMENT_SLUG, orderDocumentMetadataBySlug } from "~/shared/documents/order-document-settings";
import { Divider, Input, Stack } from "~/ui";
import { emptyEditorDoc } from "~/utils/types/rich-text";

const PICKUP_INSTRUCTIONS_SLUG = ORDER_DOCUMENT_SLUG.pickupInstructions;
const PICKUP_INSTRUCTIONS_LABEL = orderDocumentMetadataBySlug[PICKUP_INSTRUCTIONS_SLUG].menuLabel;

/** Per-slug org settings editor for pickup-instructions order document boilerplate. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const PickupInstructionsOrderDocumentSettingsForm = () => {
  const { formElement } = useOptInOrderDocumentSettingsForm({
    slug: PICKUP_INSTRUCTIONS_SLUG,
    schema: PickupInstructionsDocumentConfigSchema,
    emptyConfig: PickupInstructionsDocumentConfigSchema.parse({
      deliveryInstructionsHeader: emptyEditorDoc(),
      sealWashTicketBoilerplate: emptyEditorDoc(),
      demurrageBoilerplate: emptyEditorDoc(),
    }),
    saveErrorTitle: `Error while saving ${PICKUP_INSTRUCTIONS_LABEL} document settings`,
    saveSuccessTitle: `${PICKUP_INSTRUCTIONS_LABEL} document settings saved`,
    infoAlert: (
      <>
        <OptInOrderDocumentAccessInfoAlert documentLabel={PICKUP_INSTRUCTIONS_LABEL} /> Org boilerplate below appears on the PDF (delivery
        instructions header, seal/wash ticket, demurrage).
      </>
    ),
    renderFields: (form, canEdit) => (
      <Stack spacing="md">
        <Input.Wrapper
          label="Delivery Instructions header"
          description="Optional rich text above the pick-up section (e.g. 24-hour availability line)."
        >
          <DocumentSettingsEditor disabled={!canEdit} {...form.getInputProps("deliveryInstructionsHeader")} />
        </Input.Wrapper>
        <Input.Wrapper label="Seal numbers / wash ticket requirement">
          <DocumentSettingsEditor disabled={!canEdit} {...form.getInputProps("sealWashTicketBoilerplate")} />
        </Input.Wrapper>
        <Input.Wrapper label="Demurrage boilerplate">
          <DocumentSettingsEditor disabled={!canEdit} {...form.getInputProps("demurrageBoilerplate")} />
        </Input.Wrapper>
        <DocumentTypedSignatureSettingsField
          canEdit={canEdit}
          createModalLabel="Carrier Instructions create"
          checked={form.values.allowTypedSignature}
          onChange={checked => form.setFieldValue("allowTypedSignature", checked)}
        />
        <Divider />
        <DocumentDisplayUomSettingsFields form={form} canEdit={canEdit} createModalLabel="Carrier Instructions create" />
      </Stack>
    ),
  });

  return formElement;
};
